import React from "react";
import { useFormik } from "formik";
import axios from "axios";

const ratingOptions = [
  { value: "5", label: "Excelente", stars: 5 },
  { value: "4", label: "Muy bueno", stars: 4 },
  { value: "3", label: "Bueno", stars: 3 },
  { value: "2", label: "Regular", stars: 2 },
  { value: "1", label: "Mejorable", stars: 1 },
];

export default function TestimonioForm() {
  const formik = useFormik({
    initialValues: {
      name: "",
      comment: "",
      rate: "",
    },
    onSubmit: async (formValue) => {
      const body = {
        ...formValue,
        owner: "bczt96",
      };
      axios
        .post("https://backend-bzt-production.up.railway.app/api/comment/create", body)
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-primary-lighter rounded-3xl p-8 shadow-soft">
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-soft">
            <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </div>
          <h3 className="font-heading text-2xl font-semibold text-gray-800">Deja tu comentario</h3>
          <p className="text-gray-500 font-body text-sm mt-1">Tu opinión ayuda a otras familias</p>
        </div>

        <form onSubmit={formik.handleSubmit} className="space-y-5">
          {/* Name */}
          <div>
            <label htmlFor="name" className="block text-sm font-semibold font-body text-gray-700 mb-2">
              Tu nombre
            </label>
            <input
              type="text"
              id="name"
              name="name"
              required
              placeholder="Escribe tu nombre..."
              onChange={formik.handleChange}
              value={formik.values.name}
              className="w-full bg-white border-2 border-transparent text-gray-800 font-body text-sm rounded-2xl focus:ring-2 focus:ring-primary focus:border-primary outline-none px-4 py-3 transition-all duration-200 placeholder-gray-400 shadow-sm"
            />
          </div>

          {/* Comment */}
          <div>
            <label htmlFor="comment" className="block text-sm font-semibold font-body text-gray-700 mb-2">
              Tu comentario
            </label>
            <textarea
              id="comment"
              name="comment"
              rows={4}
              required
              placeholder="Cuéntanos tu experiencia..."
              onChange={formik.handleChange}
              value={formik.values.comment}
              className="w-full bg-white border-2 border-transparent text-gray-800 font-body text-sm rounded-2xl focus:ring-2 focus:ring-primary focus:border-primary outline-none px-4 py-3 transition-all duration-200 placeholder-gray-400 resize-none shadow-sm"
            />
          </div>

          {/* Rating */}
          <div>
            <p className="block text-sm font-semibold font-body text-gray-700 mb-3">Calificación</p>
            <div className="grid grid-cols-5 gap-2">
              {ratingOptions.map((option) => (
                <label
                  key={option.value}
                  className={`cursor-pointer flex flex-col items-center gap-1 p-2 rounded-2xl border-2 transition-all duration-200 ${
                    formik.values.rate === option.value
                      ? "border-primary bg-white shadow-soft"
                      : "border-transparent bg-white/60 hover:bg-white hover:border-primary/30"
                  }`}
                >
                  <input
                    type="radio"
                    name="rate"
                    value={option.value}
                    required
                    onChange={formik.handleChange}
                    className="sr-only"
                  />
                  <svg
                    className={`w-6 h-6 ${formik.values.rate === option.value ? "text-warm" : "text-gray-300"}`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  <span className="text-xs font-body text-gray-500">{option.value}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="w-full bg-primary hover:bg-primary-dark text-white font-body font-bold py-4 px-6 rounded-2xl shadow-soft transition-all duration-200 hover:scale-[1.02] hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 cursor-pointer"
          >
            Publicar comentario
          </button>
        </form>
      </div>
    </div>
  );
}
